import React from 'react'

import {FaInstagram} from 'react-icons/fa';
//import Harpur from "../images/svg/BU-Harpur.svg";


import "./style/footer.css"

const Footer = ({departmentTitle, link, description, universityAddress, universityTitle, instagramLink}) => (
  <div id="footer">
    <div className="inner">
      <div className="grid">
        <div className="width-12-12-m width-7-12 footer-title">
          <div className="footer-inner">
            <a class="logo" target="_blank" rel="noopener noreferrer" title={departmentTitle+', '+universityTitle} href={link}>
              <h4>{departmentTitle}</h4>
              <h5>{universityTitle}</h5>
            </a>
            <p>{description}</p>
          </div>
        </div>


        <div className="width-12-12-m width-7-12 footer-address">
          <div className="footer-inner address">
            <p>{universityAddress}</p>
          </div>
        </div>


        <div className="width-12-12-m width-5-12 footer-over">
          <div className="footer-inner">
            <div className="social">
            <p><a rel="noopener noreferrer" aria-label="Instagram" title="Instagram" href={instagramLink} target="_blank"><FaInstagram /></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer